import { API } from "../../core/apiurl";
import { TApiServiceOptions } from "../apiService";
import { authenticatedApiService } from "../apiservice.auth";
import { TQASupervisorListResponse } from "../manage-users/manage-users.types";
import { TUser } from "../user";
import {
  TCampaignsResponse,
  TEntityFeatureShoHideFlagResponse,
  TServicesResponse,
  TExcelExportResponse,
  TUserDeactivationResponse,
  TUploadResponse,
  TLanguageListResponse,
  TEmployeeAgentListRes,
  TCountryResponse,
  TDateTimeSettingsData,
  TLocationListResponse,
  TDateTimeLocationDetailResponse,
  TEntityResponse,
  TUpdatePrimaryRoleRequestPayload,
  TUpdatePrimaryRoleResponsePayload,
  TFailedCategoryCountsResponseNew,
  TEmployeeSupervisorListResponseSchema,
  TTemplateLookupResponse,
  TEmployeeListBasedRankResponseSchema,
} from "./common.types";

class CommonService {
  // methods
  getCampaigns(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.get<TCampaignsResponse>(
      API.campaigns + query,
      options,
    );
  }

  getCountryList(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.get<TCountryResponse>(
      API.country_list + query,
      options,
    );
  }

  getStateList(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.get<TCountryResponse>(
      `${API.state_list}?country_internal_id=` + query,
      options,
    );
  }

  getServices(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.get<TServicesResponse>(
      API.services + query,
      options,
    );
  }

  // get capabilities list
  getEntityList(options?: TApiServiceOptions) {
    return authenticatedApiService.get<TEntityResponse>(
      API.entity_list,
      options,
    );
  }

  getEntityFeatureShowHideFlag(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.get<TEntityFeatureShoHideFlagResponse>(
      API.entity_feature_showHideFlag + "?entity_internal_id=" + query,
      options,
    );
  }

  getUserDetails(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.get<TUser>(API.userDetails + query, options);
  }
  // Getting the location list
  getLocationList(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.get<TLocationListResponse>(
      API.location + query,
      options,
    );
  }
  // Exporting the user list
  getExcelExport(query: string, options?: TApiServiceOptions) {
    const config = {
      ...options,
      timeout: 60000,
    };
    return authenticatedApiService.get<TExcelExportResponse>(
      API.export + query,
      config,
    );
  }
  // Deleting the user from the user list
  getUserDeactivation(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.patch<TUserDeactivationResponse>(
      API.delete + query,
      options,
    );
  }
  //Upload File API
  uploadFile(file: File, options?: TApiServiceOptions) {
    const formData = new FormData();
    formData.append("file", file);
    return authenticatedApiService.post<TUploadResponse>(API.upload, formData, {
      ...options,
      headers: {
        ...options?.headers,
      },
    });
  }

  // get user agent list
  getAgentList(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.get<TQASupervisorListResponse>(
      API.agent + query,
      options,
    );
  }

  // get employee agent list
  getEmployeeAgentList(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.get<TEmployeeAgentListRes>(
      API.employee_agent_list + query,
      options,
    );
  }

  // get user agent list
  getEmployeeSupervisorList(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.get<TEmployeeSupervisorListResponseSchema>(
      API.employee_supervisor_list + query,
      options,
    );
  }

  // get QA supervisor list
  getQASupervisorList(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.get<TQASupervisorListResponse>(
      API.employee_supervisor_list + query,
      options,
    );
  }

  // Getting the location list
  getLanguageList(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.get<TLanguageListResponse>(
      API.language + query,
      options,
    );
  }

  updateLocation(payload: TDateTimeSettingsData, options?: TApiServiceOptions) {
    return authenticatedApiService.patch<TDateTimeSettingsData>(
      `${API.date_time_locations}${payload?.internal_id}/`,
      payload,
      options,
    );
  }
  getLocationsList(options?: TApiServiceOptions) {
    return authenticatedApiService.get<TLocationListResponse>(
      `${API.date_time_locations_list}`,
      options,
    );
  }

  getLocationDetail(
    location_internal_id: string,
    options?: TApiServiceOptions,
  ) {
    return authenticatedApiService.get<TDateTimeLocationDetailResponse>(
      `${API.date_time_locations}${location_internal_id}`,
      options,
    );
  }

  deleteLocation(location_internal_id: string, options?: TApiServiceOptions) {
    return authenticatedApiService.delete<TLocationListResponse>(
      `${API.date_time_locations}${location_internal_id}/`,
      options,
    );
  }

  updatePrimaryRole(
    payload: TUpdatePrimaryRoleRequestPayload,
    options?: TApiServiceOptions,
  ) {
    return authenticatedApiService.patch<TUpdatePrimaryRoleResponsePayload>(
      API.selectPrimaryRole,
      payload,
      options,
    );
  }

  // ---------------  Failed Category Counts  ---------------------
  failedCategoryCounts = (query: string, options?: TApiServiceOptions) => {
    return authenticatedApiService.get<TFailedCategoryCountsResponseNew>(
      API.evaluation_dashboard_failed_category_count + query,
      options,
    );
  };

  getTemplateLookup(options?: TApiServiceOptions) {
    return authenticatedApiService.get<TTemplateLookupResponse>(
      API.template_lookup,
      options,
    );
  }

  // get Employee  list based on rank
  getEmployeeListRank(query: string, options?: TApiServiceOptions) {
    return authenticatedApiService.get<TEmployeeListBasedRankResponseSchema>(
      API.employees_list_rank + query,
      options,
    );
  }
}

export const commonService = new CommonService();
